import { render, staticRenderFns } from "./degene.vue?vue&type=template&id=648b2e46&"
import script from "./degene.vue?vue&type=script&lang=js&"
export * from "./degene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports